<script>
  import { ui } from '../lib/stores/ui.svelte.js';
  import { auth } from '../lib/stores/auth.svelte.js';
</script>

{#if auth.user && !ui.elvieOpen}
  <button
    class="elvie-fab"
    onclick={() => ui.toggleElvie()}
    title="Talk to Elvie — your business coach"
    type="button"
  >
    <span class="elvie-orb-wrap">
      <span class="elvie-halo"></span>
      <img class="elvie-orb" src="https://res.cloudinary.com/dj0spw2w8/image/upload/v1778104240/BLV_icon_transparent_dcpgpl.png" alt="" />
    </span>
    <span class="elvie-wordmark">ELVIE</span>
  </button>
{/if}

<style>
  .elvie-fab {
    position: fixed;
    bottom: 24px;
    right: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    margin: 0;
    z-index: 40;
  }
  .elvie-orb-wrap {
    position: relative;
    width: 72px;
    height: 72px;
    display: block;
  }
  .elvie-halo {
    position: absolute;
    inset: -14px;
    border-radius: 50%;
    background: radial-gradient(closest-side,
      rgba(180,140,255,0.45) 0%,
      rgba(120,180,255,0.25) 45%,
      rgba(180,140,255,0) 75%);
    filter: blur(14px);
    pointer-events: none;
    z-index: 0;
  }
  .elvie-orb {
    position: relative;
    width: 72px;
    height: 72px;
    display: block;
    border-radius: 50%;
    z-index: 1;
    animation: elvieSpin 5s ease-in-out infinite;
    transform-origin: center center;
    transition: transform 0.18s ease;
  }
  .elvie-fab:hover .elvie-orb {
    transform: scale(1.05);
    animation-play-state: paused;
  }
  @keyframes elvieSpin {
    0%   { transform: rotate(0deg); }
    70%  { transform: rotate(360deg); }
    100% { transform: rotate(360deg); }
  }
  .elvie-wordmark {
    font-family: 'DM Serif Display', serif;
    font-size: 13px;
    letter-spacing: 2px;
    color: #ffffff;
    text-transform: uppercase;
    text-shadow: 0 2px 12px rgba(180,140,255,0.4);
  }
</style>
